import {
    faChartLine, faFunnelDollar, faMapMarkedAlt, faSearchDollar,
    faFileSignature, faTags, faBinoculars,
} from '@fortawesome/free-solid-svg-icons';

export const BIZDEV_NAV = [
    { to: '/bizdev', label: 'Growth Overview', icon: faChartLine, end: true },
    { to: '/bizdev/pipeline', label: 'Pipeline & Deals', icon: faFunnelDollar },
    { to: '/bizdev/territory', label: 'Market Coverage', icon: faMapMarkedAlt },
    { to: '/bizdev/prospecting', label: 'Prospecting', icon: faSearchDollar },
    { to: '/bizdev/proposals', label: 'Proposals & RFPs', icon: faFileSignature },
    { to: '/bizdev/pricing', label: 'Pricing & Packaging', icon: faTags },
    { to: '/bizdev/competitors', label: 'Competitive Intel', icon: faBinoculars },
];

export const STAGE_COLORS: Record<string, string> = {
    new: 'secondary', contacted: 'info', qualified: 'primary',
    proposal: 'warning', negotiation: 'warning', won: 'success', lost: 'danger',
};

export const PROPOSAL_COLORS: Record<string, string> = {
    draft: 'secondary', sent: 'info', under_review: 'warning',
    accepted: 'success', declined: 'danger', withdrawn: 'dark',
};
